import { createAction, props } from "@ngrx/store";

export const submitFirstTimeUserAgreement = createAction(
  '[First-Time User Agreement] Submit agreement clicked'
);

export const submitFirstTimeUserAgreementSuccess = createAction(
  '[First-Time User Agreement] Submit agreement success'
);

export const submitFirstTimeUserAgreementFailure = createAction(
  '[First-Time User Agreement] Submit agreement Failed',
  props<{ errorMsg: any}>()
);